module.exports = __webpack_public_path__ + "img/icon-social-x.ec3d34f6.svg";